<template>
  <div class="mouse-down  pt-16">
    <a class="w-24 block mouse-link mx-auto" href="#list">
    <svg class="mx-auto" width="39" height="86" viewBox="0 0 39 86" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4527 53.9823H19.4522C9.85385 53.9823 2.00027 46.1301 2.00027 36.533V19.4488C2.00027 9.85163 9.85385 2 19.4522 2H19.4527C29.0511 2 36.9047 9.85163 36.9047 19.4488V36.533C36.9047 46.1301 29.0511 53.9823 19.4527 53.9823Z" stroke="white" stroke-width="3"/>
      <path d="M19.4528 12.3852V19.1588" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M28.5405 62.7633L19.453 71.8496L10.3645 62.7633" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M28.5405 74.8699L19.453 83.9562L10.3645 74.8699" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </a>
  </div>
</template>

<script>
export default {
    name: 'MouseDown'
}
</script>
<style scoped>
.mouse-link {
  opacity: 0.4;
  transition: all .8s ease;
}
.mouse-link:hover {
  opacity: 1;
}
</style>